<template>
    <a class="float-right sair" v-if="$store.state.user" href="/" @click="logout">
      <i class="fas fa-power-off"></i>{{logoutTranslation}}</a>
</template>

<script>
export default {
  props: {
    logoutTranslation: String
  },
  methods: {
    logout: function () {
      document.cookie.split(';').forEach(function (c) { document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/') })
      this.axios.get('/backoffice/logout').then((res) => {
        console.log(res)
      }).catch((er) => {
        console.log(er)
      })
    }
  }
}
</script>
